import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useMemo } from "react";
import { useSelector } from "react-redux";
// components
import UsageBlockOptionCard from "./UsageBlockOptionCard";
import LoadingSpinner from "module/common/components/LoadingSpinner";
// store
import { selectUsageBlockOptions } from "module/main/store/auth/selectors";
var UsageBlockOptions = function (_a) {
    var onSelectCallback = _a.onSelectCallback, _b = _a.isShowcase, isShowcase = _b === void 0 ? false : _b;
    var usageBlockOptions = useSelector(selectUsageBlockOptions);
    var options = useMemo(function () {
        if (!usageBlockOptions)
            return null;
        return usageBlockOptions.map(function (option, index, arr) {
            var colClassName = arr.length % 2 === 1 && index === arr.length - 1 ? "sm:col-span-2" : "";
            return (_jsx(React.Fragment, { children: _jsx(UsageBlockOptionCard, { usageBlockOption: option, className: colClassName, onClick: onSelectCallback ? function () { return onSelectCallback(option); } : undefined }) }, index));
        });
    }, [usageBlockOptions]);
    if (!options) {
        return (_jsx("div", { className: "pt-10", children: _jsx(LoadingSpinner, { color: "primary", className: "mx-auto w-11 h-11" }) }));
    }
    return (_jsxs(_Fragment, { children: [isShowcase ? (_jsx("h3", { className: "block text-center py-3", children: "Current Pricing for Usage Blocks (Subject to Changes/Promos)" })) : null, _jsx("div", { className: "grid grid-cols-1 sm:grid-cols-2 gap-4", children: options })] }));
};
export default UsageBlockOptions;
